"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCover = void 0;
var _styled = require("../../styled");
//
// Styled components
// -------------------------------------------------------------------------------------------------

const StyledCover = (0, _styled.styled)('div', {
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  '& > *': {
    flexGrow: 1
  },
  variants: {
    /**
     * The amount of horizontal space to insert between the child components.
     * @type $space
     */
    gap: {
      true: {
        gap: '$3'
      },
      none: {
        gap: '$none'
      },
      px: {
        gap: '$px'
      },
      0.5: {
        gap: '$0.5'
      },
      1: {
        gap: '$1'
      },
      1.5: {
        gap: '$1.5'
      },
      2: {
        gap: '$2'
      },
      2.5: {
        gap: '$2.5'
      },
      3: {
        gap: '$3'
      },
      3.5: {
        gap: '$3.5'
      },
      4: {
        gap: '$4'
      },
      5: {
        gap: '$5'
      },
      6: {
        gap: '$6'
      },
      7: {
        gap: '$7'
      },
      8: {
        gap: '$8'
      },
      9: {
        gap: '$9'
      },
      10: {
        gap: '$10'
      },
      11: {
        gap: '$11'
      },
      12: {
        gap: '$12'
      }
    }
  }
});
exports.StyledCover = StyledCover;